export const ROUTE_SHIPPER_PROD_SUPPORT = 'shipper-prod-support';
export const ROUTE_SHIPPER_SEARCH = 'shipper-search';
export const ROUTE_SHIPMENT_SEARCH = 'shipment-search';
